module.exports = __webpack_public_path__ + "aec82b74fa1e9a7acd6a29b0c15679a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-teal-s.png
// module id = 2754
// module chunks = 0